import React, { useRef, useEffect } from "react";
import { MapProps } from "../../../interfaces/map";
import { MapService } from "../../../services/map";
import "./map.scss";

const Map: React.FC<MapProps> = ({ lat, lng, zoom }) => {
  const mapRef: any = useRef();

  useEffect(() => {
    setTimeout(() => {
      MapService.initMap(mapRef.current, { lat, lng, zoom });
    }, 1000);
  }, []);

  return (
    <div className="map-wrapper">
      <div className="google-map" ref={mapRef}></div>
    </div>
  );
};

export default Map;
